import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

export interface ColumnReorderItem {
  id: string
  label: string
}

interface ColumnReorderMobileDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description?: string
  items: ColumnReorderItem[]
  onMoveUp: (index: number) => void
  onMoveDown: (index: number) => void
}

/**
 * Touch-friendly column reordering (▲/▼). Shown from narrow viewports where
 * HTML5 `draggable` on table headers does not work reliably.
 */
export function ColumnReorderMobileDialog({
  open,
  onOpenChange,
  title,
  description = "Use the arrows to change column order. Changes apply immediately.",
  items,
  onMoveUp,
  onMoveDown,
}: ColumnReorderMobileDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[85dvh] overflow-y-auto border-[#4a4a4a] bg-[#2d2d2d] text-white sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-white">{title}</DialogTitle>
          <DialogDescription className="text-[#b0b0b0]">
            {description}
          </DialogDescription>
        </DialogHeader>
        <ul className="space-y-2">
          {items.map((item, index) => (
            <li
              key={item.id}
              className="flex items-center justify-between gap-2 rounded-md border border-[#4a4a4a] bg-[#252525] px-3 py-2"
            >
              <span className="min-w-0 flex-1 truncate text-sm text-[#e8e8e8]">
                {item.label}
              </span>
              <div className="flex shrink-0 gap-1">
                <button
                  type="button"
                  disabled={index === 0}
                  onClick={() => onMoveUp(index)}
                  className="rounded border border-[#555] bg-[#3a3a3a] px-2 py-1 text-xs font-medium text-white disabled:cursor-not-allowed disabled:opacity-30"
                  aria-label={`Move ${item.label} up`}
                >
                  ▲
                </button>
                <button
                  type="button"
                  disabled={index >= items.length - 1}
                  onClick={() => onMoveDown(index)}
                  className="rounded border border-[#555] bg-[#3a3a3a] px-2 py-1 text-xs font-medium text-white disabled:cursor-not-allowed disabled:opacity-30"
                  aria-label={`Move ${item.label} down`}
                >
                  ▼
                </button>
              </div>
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  )
}
